import {dataLayerPush} from "Core/helpers/dataLayerHelper";
import productObjects from "Core/productObjects";
import {isEmpty} from 'lodash';

export const downloadFile = (isPerson, period, tariffType, url, platform) => {
    if (isEmpty(productObjects)) {
        return;
    }

    if (isEmpty(productObjects[period])) {
        return;
    }

    if (isEmpty(productObjects[period][tariffType])) {
        return;
    }

    dataLayerPush(
        downloadFileItem(url, platform, period, tariffType, isPerson)
    );
};

const downloadFileItem = (url, platform, period, tariffType, isPerson) => {
    const product = productObjects[period][tariffType];
    const person = isPerson ? 'Person' : 'Company'
    product['dimension1'] = platform;
    product['dimension2'] = url;

    return {
        'ecommerce':
            {
                'currencyCode': 'USD',
                'checkout': {
                    'actionField': {'step': 3, 'option': person},
                    'products': [product]
                }
            },
        'event': 'gtm-ee-event',
        'gtm-ee-event-category': 'Enhanced Ecommerce',
        'gtm-ee-event-action': 'Checkout Step 3',
        'gtm-ee-event-non-interaction': 'False',
    };
};
